export const LOGIN = 'auth/LOGIN'
export const LOGOUT = 'auth/LOGOUT'
export const REGISTER = 'auth/REGISTER'
export const RESET_FORM = 'auth/RESET_FORM'
export const VERIFY_EMAIL = 'auth/VERIFY_EMAIL'
export const REFRESH_TOKEN = 'auth/REFRESH_TOKEN'
export const REFRESH_TOKEN_ERROR = 'auth/REFRESH_TOKEN_ERROR'
